var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"35.2632","height":"35.2632","transform":"matrix(-1 0 0 1 36 0.736816)","stroke":"black","key":0}),React.createElement("path",{"d":"M10.258 17.4868H19.0738H26.479C26.8686 17.4868 27.1843 17.8026 27.1843 18.1921C27.1843 18.5816 26.8686 18.8973 26.479 18.8973H17.6633H10.258C9.86848 18.8973 9.55273 18.5816 9.55273 18.1921C9.55273 17.8026 9.86848 17.4868 10.258 17.4868Z","fill":"black","key":1})]);
}

Minus.defaultProps = {"width":"37","height":"37","viewBox":"0 0 37 37","fill":"white"};

module.exports = Minus;

Minus.default = Minus;
